import { render, staticRenderFns } from "./Lase.vue?vue&type=template&id=e0bc82c8&scoped=true&"
import script from "./Lase.vue?vue&type=script&lang=js&"
export * from "./Lase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bc82c8",
  null
  
)

export default component.exports